/** Matches backend `PushNotificationType` — FCM `data.type` string values. */
export enum PushNotificationType {
  ORDER_CREATED = 'order_created',
  STAFF_NEW_ORDER = 'staff_new_order',
  ORDER_STATUS_UPDATE = 'order_status_update',
  STORE_STATUS = 'store_status',
}
